module.exports = __webpack_public_path__ + "static/media/Portrait-10040.2cc19caf.jpg";